import React from 'react';
export function Footer() {
  return <footer className="bg-zinc-950 border-t border-violet-900 py-10 px-4 text-center" data-id="element-117" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white/60" data-id="element-118" data-mp="3gg0xbxz0nnv0">© MMA Coach Ready 2026 — All rights reserved.</p>
      <p className="text-xs text-white/40 mt-2" data-id="element-119" data-mp="32p5naics70pu">
        MMA Coach Ready is an independent coaching resource and is not affiliated with UFC or any
        professional fighting promotion.
      </p>
    </footer>;
}